// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 516) return "content/plugin-post-stage-report/b1c01f5b2746d24c8011004198447cd6.js";
	// return url for filenames based on template
	return undefined;
};